/**
 * Created by guga on 8/30/2016.
 */
import { Response } from '@angular/http';

import { Observable } from 'rxjs/Observable';

import { IRequestErrorHandler, IXhrErrorHandler } from "../sas-models/error-handler";
import { ErrorHandlerSas }                        from '../sas/error-handler.sas';
import { IRequestPayload }                        from '../sas-models/request-payload';
import { IXhrResponse, IXhrRequestPayload }       from '../sas-models/xhr-types';

export class BaseSas {
    private _customAuthenticationErrorHandler : IRequestErrorHandler = null;
    private _customRequestErrorHandler : IRequestErrorHandler = null;
    private _customXhrErrorHandler : IXhrErrorHandler = null;

    public constructor(private _errorHandler : ErrorHandlerSas) {}

    private _authenticationErrorHandler(error : Response, requestPayload : IRequestPayload) : Observable<any> {
        if (!this._customAuthenticationErrorHandler)
            return this._errorHandler.authenticationErrorHandler(error, requestPayload);
        return this._customAuthenticationErrorHandler(error, requestPayload);
    };
    private _requestErrorHandler(error : Response, requestPayload : IRequestPayload) : Observable<any> {
        if (!this._customRequestErrorHandler)
            return this._errorHandler.requestErrorHandler(error, requestPayload);
        return this._customRequestErrorHandler(error, requestPayload);
    };
    private _xhrErrorHandler(error : IXhrResponse, requestPayload : IXhrRequestPayload) : Observable<any> {
        if (!this._customXhrErrorHandler)
            return this._errorHandler.xhrErrorHandler(error, requestPayload);
        return this._customXhrErrorHandler(error, requestPayload);
    }

    get authenticationErrorHandler() : IRequestErrorHandler {
        return this._authenticationErrorHandler.bind(this);
    }
    public setAuthenticationErrorHandler(authenticationErrorHandler : IRequestErrorHandler) : void {
        this._customAuthenticationErrorHandler = authenticationErrorHandler;
    }

    get requestErrorHandler() : IRequestErrorHandler {
        return this._requestErrorHandler.bind(this);
    }
    public setRequestErrorHandler(requestErrorHandler : IRequestErrorHandler) : void {
        this._customRequestErrorHandler = requestErrorHandler;
    }

    get xhrErrorHandler() : IXhrErrorHandler {
        return this._xhrErrorHandler.bind(this);
    }
    public setXhrErrorHandler(xhrErrorHandler : IXhrErrorHandler) : void {
        this._customXhrErrorHandler = xhrErrorHandler;
    }
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/sas/base.sas.ts